import { Redirect, Route, Switch, useParams } from "react-router-dom";
import { DealSettingsPage } from "./DealSettingsPage";

export function DealSettings() {
  const { dealId } = useParams<{ dealId: string }>();

  return (
    <Switch>
      {/* Redirect old company/custom-properties routes */}
      <Route path="/deal/:dealId/settings/company">
        <Redirect to={`/deal/${dealId}/settings/details`} />
      </Route>
      <Route>
        <DealSettingsPage />
      </Route>
    </Switch>
  );
}
